<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row no-gutters">
        <!-- Vue does not like us adding style tags in our templates, so we use a property to do it for us -->
        <span v-html="defaultStyle"></span>
        
        <modal ref="defaultSettingsModal"
            @hidden="resetDraftTemplateDefaultSettings"
        >
            <template v-slot:modal-body>
                <template-default-settings 
                    class="w-50 mx-auto"
                    v-model="draftTemplateDefaultSettings"
                ></template-default-settings>
            </template>

            <template v-slot:modal-footer>
                <button class="btn btn-primary" @click="applyDraftDefaultSettings">Toepassen</button>
            </template>
        </modal>
        
        <div class="col-2">
            <div class="template-manager-settings template-manager-left" ref="settingsLeft">
                <TemplateSettings
                        v-if="name != null && subject != null"
                        v-bind:name="name"
                        v-bind:subject="subject"
                        v-bind:sender="sender"
                        v-bind:sender-name="senderName"
                        v-bind:custom-css="customCss"
                        v-bind:templates="templates"
                        v-bind:parentId="parentId"
                        v-bind:modified="modifiedFormatted"
                        v-bind:canPickParent="canPickParent"
                        v-on:rename-template="$emit('change-name', $event)"
                        v-on:rename-subject="$emit('change-subject', $event)"
                        v-on:rename-sender="$emit('change-sender', $event)"
                        v-on:rename-sender-name="$emit('change-sender-name', $event)"
                        v-on:change-custom-css="$emit('change-custom-css', $event)"
                        v-on:set-parent="$emit('set-parent', $event)"
                />
            </div>
        </div>
        
        <div class="col-8">
        
            <div class="template-manager-template">
                <div class="row">
                    <div class="col-11 mx-auto">
                        <h3>{{name}}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="mx-auto col-11 p-2 text-center template-header">

                        <span class="template-header-icon">
                            <i class="fas fa-mail-bulk fa-3x text-white"></i>
                        </span>

                        <template-header class="d-inline-block" v-bind:size="templateDefaultSettings.headingSize">{{subject}}</template-header>

                        <i
                            v-if="parentId === null"
                            @click="showDefaultSettingsModal"
                            class="fas fa-lg fa-ellipsis-v float-right mdb-icon-btn edit"
                            aria-hidden="true"
                        ></i>
                    </div>

                    <div class="mx-auto col-11 template-container">

                        <TemplateItem
                            classes="template p-3 border bg-light"
                                
                            v-bind:metadata="{}"
                            v-bind:isSelected="false"
                            v-bind:parentId="parentId"
                            v-bind:controlsStyle="'top: -45px;'"
                            v-bind:isParent="parentId != null"
                            v-bind:locked="locked"
                            v-bind:hideSort="true"
                            v-bind:hideDelete="true"
                            v-on:unselect-all="selectedPage = null"
                            v-on:lock-item="$emit('lock-template', $event)"
                            >
                        
                            <templatePage
                                v-for="page in sortedPages"
                                v-bind:key="page._key"
                               
                                v-bind:id="page.Id"
                                v-bind:parentId="page.ParentId"
                                v-bind:currentTemplateId="id"
                                v-bind:templateId="page.TemplateId"
                                v-bind:name="page.Name"
                                v-bind:metadata="page.Metadata"
                                v-bind:blocks="page.Blocks"
                                v-bind:isSelected="selectedPage === page"
                                v-bind:locked="page.IsLocked"
                                v-bind:lockStateChanged="page.LockStateChanged"

                                v-on:select-page="selectedPage = page"
                                v-on:delete-page="deletePage($event)"
                                v-on:move-page="movePage($event.old, $event.new)"
                                v-on:rename-page="page.Name = $event"
                                v-on:lock-page="togglePageLock(page, $event)"
                                v-on:unselect-all="selectedPage = null"

                                v-on:change-width="page.Metadata.style.width = $event"
                                v-on:change-color="page.Metadata.style.color = $event"
                                v-on:change-crop="setCrop(page, $event)"
                                v-on:change-image="page.Metadata.style.mediaId = $event"
                                v-on:change-margin="page.Metadata.style.margin = $event"
                                v-on:item-added="itemAdded = true"
                            >

                                <template v-slot:pagenumber>
                                    <span class="pull-right">{{resource('Template_PageNumber_Page_Label')}} {{ page.Metadata.index }}</span>
                                </template>

                            </templatePage>

                            <div v-if="!controlsLocked">
                                <i class="mdb-icon-btn new fa fa-plus-circle fa-3x page-btn" v-on:click.stop="addPage()"></i>
                            </div>

                        </TemplateItem>
                    </div>
                </div>
            </div>
            
            <slot></slot>
        </div>
        <div class="col-2">
            <div class="template-manager-settings template-manager-right" ref="settingsRight">
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    
    import dataStore from '../Util/data-store';
    
    import generateRuleset from '../CustomStylingOptions/ruleset-generator';
    import resourceMixin from '../../../Util/Mixins/resources';
    import {applyDefaults, pageDefaults} from "../defaults";
    import guidMixin from '../../../Util/Mixins/guid';

    import Modal from "../../../Components/Util/Modal.vue";
    
    import TemplateHeader from "./TemplateHeader.vue";
    import TemplateDefaultSettings from "./Settings/TemplateDefaultSettings.vue";
    import TemplateSettings from './Settings/TemplateSettings.vue';
    import TemplateItem from './TemplateItem.vue';
    import Page from './TemplatePage.vue';
    
    const DEFAULT_SETTINGS_DATASTORE_KEY = 'DEFAULT_SETTINGS';
    
    export {
        DEFAULT_SETTINGS_DATASTORE_KEY
    }
    
    export default {
        name: "template-manager-template",
        mixins: [resourceMixin,guidMixin],
        components: {
            Modal,

            TemplateHeader,
            TemplateItem,
            TemplateSettings,
            'TemplatePage': Page,
            TemplateDefaultSettings
        },
        created(){
            const vm = this;

            //Ensure our draft values match
            vm.resetDraftTemplateDefaultSettings();
            dataStore.set(DEFAULT_SETTINGS_DATASTORE_KEY, vm.templateDefaultSettings);
        },
        mounted(){
            const vm = this;
            
            //Our header is fixed; our settings should always stay under it
            const headerHeight = $('.main-header').height();
            
            //We don't want our settings to stretch off screen
            //This means we'll have to use our element top as our 0 position
            const elementTop = vm.$el.getBoundingClientRect().top;
            
            //A static height is required for our scrollbar to properly work
            //Window - element top height should yield the actual visible, usable part of the page
            const elementHeight = window.innerHeight - elementTop;
            
            const settingsSelector = $(vm.$refs.settingsLeft)
                .add(vm.$refs.settingsRight);
            
            //IE spazzes out when an element has display: flex, a set height, and more elements than fit in the given height
            //Therefor we'll need to wrap our settings with a new, non flex div, and continue our configuration with said div 
            settingsSelector.wrap('<div style="overflow-y: scroll"/>')
                .parent()
                .height(elementHeight)
                .sticky({topSpacing: headerHeight});
        },
        methods: {
            addPage() {
                const vm = this;

                let page = {
                    _key: vm.guid(),
                    TemplateId: vm.id,
                    Name: '<empty>',
                    IsLocked: false,
                    LockStateChanged: false,
                    Metadata: {
                        index: vm.lastPage + 1
                    },
                    Blocks: []
                };

                applyDefaults(pageDefaults, page.Metadata);
                
                vm.pages.push(page);
                this.itemAdded = true;
            },
            deletePage(index) {
                var vm = this;
                
                if(vm.selectedPage === vm.pages[index-1]){
                    vm.selectedPage = null;
                }

                vm.$nextTick(() => {
                    vm.pages.splice(index-1,1);
                    vm.reIndex();
                });

            },
            togglePageLock(page, locked) {
                page.IsLocked = locked;
                page.LockStateChanged = !page.LockStateChanged;
            },
            movePage(oldIndex, newIndex) {
                let pages = this.pages;
                var target = pages.splice(oldIndex-1, 1)[0];
                pages.splice(newIndex-1, 0, target);

                this.reIndex();
                
            },
            reIndex() {
                const pages = this.pages;

                for(let i = 0 ; i < pages.length ; i++) {
                    pages[i].Metadata.index = i+1;
                }
            },
            setCrop(page, crop){
                //Ensure our crop is actually present
                if(!page.Metadata.style.crop) page.Metadata.style.crop = crop;
                
                //Manually copy over our properties
                //This seems to do the trick regarding reactiveness and all
                page.Metadata.style.crop.x = crop.x;
                page.Metadata.style.crop.y = crop.y;
                page.Metadata.style.crop.w = crop.w;
                page.Metadata.style.crop.h = crop.h;
            },
            applyDraftDefaultSettings(){
                const vm = this;

                //Copy our draft settings to our 'live' settings
                Object.keys(vm.draftTemplateDefaultSettings)
                    .forEach(key => vm.templateDefaultSettings[key] = vm.draftTemplateDefaultSettings[key]);

                //Close the modal
                vm.hideDefaultSettingsModal();
            },
            resetDraftTemplateDefaultSettings(){
                const vm = this;

                vm.draftTemplateDefaultSettings = {};

                //Copy our 'live' settings to our draft settings
                Object.keys(vm.templateDefaultSettings)
                    .forEach(key => vm.draftTemplateDefaultSettings[key] = vm.templateDefaultSettings[key]);
            },
            showDefaultSettingsModal(){
                this.$refs.defaultSettingsModal.show();
            },
            hideDefaultSettingsModal(){
                this.$refs.defaultSettingsModal.hide();
            }
        },
        watch: {
            templateDefaultSettings: {
                handler(value){
                    dataStore.set(DEFAULT_SETTINGS_DATASTORE_KEY, value);
                },
                deep: true
            },
            id(value){
                //Should be triggered upon save after selecting a parent template
                if(value !== this.emptyGuid() && this.pages.length){
                    this.itemAdded = true;
                }
            },
            pages(value) {
                if(value.length === 0) {
                    this.itemAdded = false;
                }
            }
        },
        computed: {
            canPickParent() {
                return this.id === this.emptyGuid() || !this.itemAdded;
            },
            lastPage() {
                return this.pages.length;
            },
            modifiedFormatted() {
                if(this.modified != null){
                    //Date is provided in local
                    return moment(this.modified)
                        .format('DD-MM-YYYY HH:mm:ss');   
                }
            },
            sortedPages() {
                return this.pages.sort((left, right) => {
                    if(left.Metadata.index < right.Metadata.index)
                        return -1;
                    if(left.Metadata.index > right.Metadata.index)
                        return 1;
                    return 0;
                });
            },
            defaultStyle(){
                const textRules = generateRuleset(this.templateDefaultSettings);
                const blockRules = generateRuleset();
                
                textRules.setRule('overflow-x', 'hidden'); //Required for IE
                textRules.setRule('padding-left', `${this.templateDefaultSettings.blockPadding}px`);
                textRules.setRule('padding-right', `${this.templateDefaultSettings.blockPadding}px`);
                
                blockRules.setRule('width', `${this.templateDefaultSettings.blockWidth}px`);
                
                return `
                    <style>
                        .template-manager-template .ql-editor {
                            ${textRules} 
                         }
                         
                         .template-block {
                            ${blockRules}
                         }
                    </style>`;
            },
            controlsLocked() {
                return this.parentId != null && this.locked;
            }
        },
        data() {
            const vm = this;
            
            return {
                selectedPage: null,
                itemAdded: true,
                draftTemplateDefaultSettings: {},
                get templateDefaultSettings(){
                    return vm.metadata.defaults;
                },
                set templateDefaultSettings(value){
                    vm.metadata.defaults = value;
                }
            }
        },
        props: {
            id: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            subject: {
                type: String,
                required: true
            },
            sender: {
                type: String
            },
            senderName: {
                type: String
            },
            customCss: {
                type: String
            },
            pages: {
                type: Array,
                required: true
            },
            locked: {
                type: Boolean,
                required: true
            },
            created: {
                type: Date,
                required: true
            },
            modified: {
                type: Date,
                required: true
            },
            state: {
                type: Number,
                required: true
            },
            templates: {
                type: Array,
                required: true
            },
            metadata: {
                type: Object,
                required: true
            },
            parentId: {
                type: String,
                default: null
            }
        }
    };
</script>

<style scoped src="../Style/template.scss" lang="scss">
</style>
